import React, { lazy, useEffect, useState, useContext } from "react";
import { GridComponent } from "../../components/core/Table/GridComponent";
import { WORK_TICKET_AUTOMATION_VIEW_ITEM_TABLE_COL, WORK_VIEW_ITEM_TABLE_COL } from "../../constants/WorkViewItemTableConstants";
import { Header } from "../../components/core/Controls";
import { Accordion, AccordionTab } from "primereact/accordion";
import styled from "styled-components";
import MMIDFlyOutView from "./MMIDFlyOutView";
import { WORK_VIEW_VEHICLE_TABLE_COL } from "../../constants/ViewWorkTicketConstants";
import { C4SContext } from "../../context/c4sContext";
import "./dropdown.css";
import { getFullName, switchTab, handleAddPage, redirectToPrevPage } from "./utils";
import _ from "lodash";
import { Loader } from "@vds/loaders";
import { SLNotification, FlexRow, CustomSLButton, Spacer } from "../../components/core/utility";
import { generate } from "shortid";
import WorkViewItemTable from "./WorkViewItemTable";
import { getWorkTicketMaterialList } from "../../services/C4S Decommission - Replacement/getWorkTicketMaterialList";
import { getWorkTicketVINList, getWorkticketVehiclesAndAssetsList } from "../../services/C4S Decommission - Replacement/getWorkTicketVINList";
import { Button } from "@vds/buttons";
import { hasPrivilege } from "../../../utility/privileges";
import { Privileges } from "../../../constants/PrivilegeConstants";
import { VehiclesDisplayTable } from "./VehiclesDisplayTable";
import { buildReturnReshipPayload, returnReship } from "../../services/C4S Decommission - Replacement/returnsHelper";
import WTCommonModal from "./WTCommonModal";
import moment from "moment";
import { getOpenJobsTabIndexFromSession, getWorkTicketHistoryFromSession } from "./navigation/tabHelpers";
import { cancelWorkticket } from "../../services/C4S Decommission - Replacement/cancelWorkticket";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import Icon from "@vds/icons";
import { Title } from "@vds/typography";
import { SplitByMaterialViewMetadata } from "./SplitByMaterialView";

const CustomDropdown = styled.select`
  width: 180px;
  height: 32px;
  padding: 0 30px 0 10px;
  font-family: "Verizon-NHG-eTX", sans-serif;
  font-size: 14px;
  color: #000000;
  background-color: #ffffff;
  border: 1px solid #6f7171;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  line-height: 32px;

  &:disabled {
    background-color: #f6f6f6;
    color: #666b6b;
    cursor: not-allowed;
    border-color: #d8dada;
  }

  &:focus {
    outline: none;
    border-color: #000000;
    box-shadow: 0 0 0 1px #000000;
  }

  &:hover:not(:disabled) {
    border-color: #000000;
  }

  option {
    padding: 8px;
    font-size: 14px;
  }

  option:disabled {
    color: #9e9e9e;
  }
`;

export const AccordionWrapper = styled.div`
  padding-top: 2.5rem;
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header:hover .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    color: #000000;
    border: none;
    padding: 0.5rem;
    background: #f6f6f6;
    box-shadow: unset;
    border-radius: unset;
  }

  .p-accordion .p-accordion-content {
    padding: 0rem;
    border: none;
  }
  .p-accordion-header-text {
    font-weight: 700;
    font-family: Verizon-NHG-eDS;
  }
`;
const GridComponentWrapper = styled.div`
  .p-datatable-scrollable .p-datatable-wrapper {
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: block !important;
      width: 5px;
      height: 5px;
    }
    ::-webkit-scrollbar-thumb {
      display: inline-block !important;
      background-color: #c0c0c0 !important;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1 !important;
    }
  }
`;

export default function DetailedWorkTicketView(props) {
  const [workTicketData, setWorkTicketData] = useState([]);
  const [workTicketVehicles, setWorkTicketVehicles] = useState([]);
  // const returnTicketListdata = [];
  const { isSourceCSP, source } = useContext(C4SContext);
  let cspCaseData = JSON.parse(sessionStorage.getItem("CSPDetails")),
    cspCaseOwner = "",
    crmReferenceId = "";
  const isWTA = sessionStorage.getItem("isWTA") === "true";
  let cspCaseDetails = {
    assignedTo: null,
    assignedToEmail: null,
    assignedToEid: null,
  };
  if (isSourceCSP.isSourceCSP) {
    cspCaseOwner = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.CSPOwner ?? "";
    crmReferenceId = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.CRM_Ref_ID ?? "";
    let cspData = cspCaseData.CSP.length ? cspCaseData.CSP.find((item) => item.DefaultCSP === "1") : {};
    cspCaseDetails = {
      assignedTo: cspData?.CSPOwner || null,
      assignedToEmail: cspData?.CSPOwnerEmail || null,
      assignedToEid: cspData?.CSPOwnerEId || null,
    };
  } else {
    cspCaseOwner = cspCaseData.CASEDetails?.filter((caseData) => caseData.DefaultCase === "1")[0]?.CaseOwner ?? "";
    crmReferenceId = cspCaseData.CASEDetails?.filter((caseData) => caseData.DefaultCase === "1")[0]?.CaseNumber ?? "";
    let caseData = cspCaseData.CASEDetails?.length ? cspCaseData.CASEDetails.find((item) => item.DefaultCase === "1") : {};
    cspCaseDetails = {
      assignedTo: caseData?.CaseOwner || null,
      assignedToEmail: caseData?.CaseOwnerEmail || null,
      assignedToEid: caseData?.CaseOwnerEId || null,
    };
  }

  const [orderTrackingData, setOrderTrackingData] = useState();
  const [isLoading, setLoader] = useState(false);
  const [notification, setNotification] = useState(null);
  const [vehicleInfoList, setVehicleInfoList] = useState([]);
  const [materialList, setMaterialList] = useState({ ...props.data });
  const [selectedAction, setSelectedAction] = useState("");
  const [commonModalStatus, setCommonModalStatus] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [actionItem, setActionItem] = useState("");
  const [modal, setModal] = useState("");
  const [splitByMaterialModal, setSplitByMaterialModal] = useState(false);
  const [splitByAckSelected, setSplitByAckSelected] = useState(false);
  let limitWT = sessionStorage.getItem("limitWTCreation") == "true" ? true : false;

  const handleShipmentDamagedModal = () => {
    setTitle("Who Damaged the Package?");
    setSubTitle("Select Who Damaged the Package");
    setActionItem("DamagedPackage");
    setCommonModalStatus(true);
  };

  const handleLostShipmentModal = () => {
    setTitle("Who Lost the Package?");
    setSubTitle("Select Who Lost the Package");
    setActionItem("LostPackage");
    setCommonModalStatus(true);
  };

  const getActionOptions = () => {
    const options = [];
    const status = props.data?.status?.toLowerCase();
    const hasEsnToBeReturned = props.data?.hasEsnToBeReturned === "true";
    const installType = props.data?.installType;
    const allowCancel = props.data?.allowCancel;
    if (
      installType === "VMI" &&
      (status === "released" ||
        status === "shipped" ||
        status === "backordered" ||
        status === "created" ||
        status === "submitted" ||
        status === "packaging" ||
        status === "delivered")
    ) {
      options.push({ label: "Schedule", value: "Schedule" });
    }

    if (status === "error") {
      options.push({ label: "Cancel Ticket", value: "Cancel" });
    }

    if ((status === "released" || status === "backordered" || status === "submitted" || status === "created") && allowCancel) {
      options.push({ label: "Cancel Work Ticket", value: "CancelShipment" });
    }

    if (status === "backordered") {
      options.push({ label: "Split by Material", value: "Split" });
    }

    if ((status === "shipped" || status === "delivered") && !hasEsnToBeReturned) {
      options.push({ label: "Return/Reship", value: "Return_Reship" });
    }

    if (status === "shipped" && !hasEsnToBeReturned) {
      options.push({ label: "Return Only After Cancellation", value: "ReturnOnly" });
    }

    if (status === "shipped" && !hasEsnToBeReturned) {
      options.push({ label: "Reship Only", value: "ReshipOnly" });
    }
    return options;
  };

  const handleActionChange = () => {
    const action = selectedAction;
    switch (action) {
      case "Schedule":
        if (
          props.data?.installType === "VMI" &&
          (props.data?.status?.toLowerCase() === "released" ||
            props.data?.status?.toLowerCase() === "shipped" ||
            props.data?.status?.toLowerCase() === "backordered" ||
            props.data?.status?.toLowerCase() === "created" ||
            props.data?.status?.toLowerCase() === "submitted" ||
            props.data?.status?.toLowerCase() === "packaging" ||
            props.data?.status?.toLowerCase() === "delivered")
        ) {
          redirectToAddJobPage();
        }
        break;
      case "Cancel":
        setCommonModalStatus(true);
        setTitle("Cancel Work Ticket");
        setSubTitle("Select Reason");
        setActionItem("Cancel");
        break;
      case "CancelShipment":
        setCommonModalStatus(true);
        setTitle("Cancel Work Ticket");
        setSubTitle("Select Reason");
        setActionItem("CancelShipment");
        break;
      case "Split":
        setSplitByMaterialModal(true);
        break;
      case "Return_Reship":
        setCommonModalStatus(true);
        setTitle("Return/Reship Reason");
        setModal("Return/Reship");
        setSubTitle("Select Reason");
        if (props.data?.status?.toLowerCase() === "shipped") {
          setActionItem("ReturnReshipShipped");
        } else if (props.data?.status?.toLowerCase() === "delivered") {
          setActionItem("ReturnReshipDelivered");
        }
        break;
      case "ReshipOnly":
        setCommonModalStatus(true);
        setTitle("Reship Reason");
        setModal("Reship");
        setSubTitle("Select Reason");
        if (props.data?.status?.toLowerCase() === "shipped") {
          setActionItem("ReshipOnlyShipped");
        } else if (props.data?.status?.toLowerCase() === "delivered") {
          setActionItem("ReshipOnlyDelivered");
        }
        break;
      case "ReturnOnly":
        handleReturnOnlyDirect();
        break;
      default:
        break;
    }
  };

  const redirectToAddJobPage = () => {
    const cspDetails = JSON.parse(sessionStorage.getItem("CSPDetails"));
    let cspAccDetails = cspDetails?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let data = {
      workTicket: {
        ...props.data,
        source: source.source,
        AccountID: cspDetails?.AccountID,
        isC4SWorkTicket: true,
        appointmentLength: 0,
        startDate: moment(new Date()).add(2, "days").format("MMMM DD,YYYY"),
        id: props?.ID,
        userId: props?.userId,
        jobDetails: [
          {
            cspSfdcId: cspAccDetails?.CSPID || "",
            cspOwner: cspAccDetails?.CSPOwner || "",
            cspName: cspAccDetails?.CSPName || "",
            caseSfdcId: cspDetails?.CASEDetails[0]?.CaseSFDCID || "",
            caseOwner: cspDetails?.CASEDetails[0]?.CaseOwner || "",
            caseNumber: cspDetails?.CASEDetails[0]?.CaseNumber || "",
            workTickets: [
              {
                workTicket: props.data.ticketId,
              },
            ],
          },
        ],
      },
      cspDetails: cspDetails,
    };
    switchTab(getOpenJobsTabIndexFromSession(), { data: data });
  };

  const handleReturnOnlyDirect = async () => {
    setLoader(true);
    const cspDetails = JSON.parse(sessionStorage.getItem("CSPDetails"));
    const payload = buildReturnReshipPayload({
      ticketDetails: props.data,
      cspDetails,
      action: "Return",
      returnReason: "",
      returnSubReason: "",
    });

    const response = await returnReship(payload);
    if (response?.status === 200 && response?.data) {
      notify("Return processed successfully", "success");
      switchTab(getWorkTicketHistoryFromSession());
    } else {
      notify("Unable to process return due to an unexpected error", "error");
    }
    setLoader(false);
    setSelectedAction("");
  };

  const handleCancelShipment = async (desc, subCode) => {
    const cspDetails = JSON.parse(sessionStorage.getItem("CSPDetails"));
    let cspAccDetails = cspDetails?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let salesOrgNumber = props.data?.salesOrg.split(" ")[0];
    let payload = {
      cspId: cspAccDetails?.CSPID || "",
      workticketId: props.data.ticketId ?? "",
      cancellationReason: desc,
      cancellationReasonCode: subCode,
      salesOrg: salesOrgNumber ?? "",
      erpTicketType: source.source === "CSP" ? "ZINS" : "ZSRQ",
      modifiedBy: `${cspDetails?.firstName} ${cspDetails?.lastName}`,
      modifiedByEmail: cspDetails?.email || "",
      modifiedByEid: cspDetails?.Employee_ID || "",
      assignedTo:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwner
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwner
          : null,
      assignedToEmail:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEmail
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEmail
          : null,
      assignedToEid:
        cspDetails?.source === "CSP"
          ? cspDetails?.CSP.length
            ? cspDetails?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEId
            : null
          : cspDetails?.CASEDetails.length
          ? cspDetails?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEId
          : null,
    };
    let missingFieldsArray = [];
    for (const key of Object.keys(payload)) {
      if (key === "workticketId" || key === "salesOrg") {
        if (payload[key] === "" || payload[key] === undefined || payload[key] === null) {
          missingFieldsArray.push(key);
        }
      }
    }
    if (missingFieldsArray.length > 0) {
      setCommonModalStatus(false);
      return setTimeout(() => {
        notify(
          "Unable to cancel work ticket due to missing information. Kindly contact IT team for support. Missing information: " +
            missingFieldsArray.toString() +
            ".",
          "error",
          false
        );
      }, 10);
    }
    setLoader(true);
    let response = await cancelWorkticket(payload);

    if (response.status === 200 && response?.data?.statusCode === "200") {
      if (response?.data?.message === "Success") {
        notify("Work ticket cancelled successfully.", "success", false);
        setCommonModalStatus(false);
        switchTab(getWorkTicketHistoryFromSession());
      } else {
        notify(response?.data?.message, "error", false);
        setCommonModalStatus(false);
      }
    } else {
      let errormessage = `${response?.data?.message || response?.data?.error || "Unable to cancel work ticket due to an unexpected error"}`;
      notify(errormessage, "error", false);
      setCommonModalStatus(false);
    }
    setLoader(false);
    setSelectedAction("");
  };

  const showSplitByMaterialView = (data) => {
    setNotification(null);
    redirectToPrevPage();
    setTimeout(() => {
      SplitByMaterialViewMetadata.name = data.ticketId;
      handleAddPage(SplitByMaterialViewMetadata.id, { data: data, AccountID: props?.AccountID, ID: props?.ID, userId: props?.userId });
    }, 0);
  };

  const TYPE_DROPDOWN = [
    { description: "Hardware accessory shipment", code: "ZHWA" },
    { description: "Mileage", code: "ZTML" },
    { description: "Customer Fee", code: "ZBTP" },
    { description: "Service-Misc", code: "ZSP1" },
    { description: "Service", code: "ZSPO" },
    { description: "Hardware shipment exchange", code: "ZZHS" },
    { description: "Hardware shipment", code: "ZHWS" },
    { description: "Hardware misc", code: "ZHS1" },
    { description: "Return Hardware", code: "ZZHR" },
    { description: "Return Accessories", code: "ZHAR" },
    { description: "Accessory Shipment Exchange", code: "ZZAE" },
  ];

  useEffect(() => {
    getWorkTicketMateriallist();
  }, []);

  const rowExpansionTemplate = (data) => (
    <MMIDFlyOutView
      data={data}
      ticketType={props.data.ticketType}
      vehicleInfoList={vehicleInfoList}
      workTicketData={workTicketData}
      workticketId={props?.data?.ticketId}
    />
  );

  useEffect(() => {
    let orderTrackingInfo = {
      plannedQuantity: [1],
      pgiDate: [1],
      selfInstalled: [0],
      installed: [1],
      returnedOrder: [1],
    };
    setOrderTrackingData(orderTrackingInfo);
  }, []);

  const getWorkTicketMateriallist = async (isRefresh = false) => {
    setLoader(true);
    let workTicketId = props.data.ticketId;
    let response = await getWorkTicketMaterialList(workTicketId);
    if (response?.status === 200 && response?.data) {
      response = response.data.data;
      setMaterialList((prev) => ({ ...prev, materials: response }));
      isRefresh ? setLoader(false) : getWorkTicketVINlist(response);
    } else {
      setMaterialList((prev) => ({ ...prev, materials: [] }));
      notify("Unable to fetch material list due to an unexpected error", "error");
      isRefresh ? setLoader(false) : getWorkTicketVINlist([]);
    }
  };

  const getWorkTicketVINlist = async (materialsData = null) => {
    setLoader(true);
    let workTicketId = props.data.ticketId;
    let response = isWTA ? await getWorkticketVehiclesAndAssetsList(workTicketId) : await getWorkTicketVINList(workTicketId);
    if (response?.status === 200 && response?.data) {
      if (isWTA) {
        response = response.data.data.vehicles.concat(response.data.data.assets);
      } else response = response.data.data;

      setVehicleInfoList(response);
      setMaterialList((prev) => ({ ...prev, vins: response }));

      if (materialsData) {
        const materialsWithVins = materialsData.map((material) => {
          const matchingVins = response.filter((vin) => {
            if (isWTA) {
              return vin.subscriptions?.some((sub) => sub.hardwareId === material.materialId && sub.techRefId === material.techRefId);
            } else {
              return vin.vinMaterialId === material.id || vin.materialId === material.materialId;
            }
          });
          const transformedVins = matchingVins
            .map((vin) => {
              if (isWTA && vin.subscriptions) {
                return vin.subscriptions
                  .filter((sub) => sub.hardwareId === material.materialId && sub.techRefId === material.techRefId)
                  .map((subscription) => ({
                    id: vin.id,
                    vin: vin.vin,
                    year: vin.year,
                    make: vin.make,
                    model: vin.model,
                    vinMaterialId: subscription.vinMaterialId,
                    vinMaterialStatus: subscription.vinMaterialStatus,
                    processingType: subscription.processingType,
                    type: subscription.type,
                    subscriptionId: subscription.subscriptionId,
                    subscriptionName: subscription.subscriptionName,
                    techRefId: subscription.techRefId,
                    hardwareId: subscription.hardwareId,
                    hardwareName: subscription.hardwareName,
                    emergency: vin.emergency,
                    wheelChair: vin.wheelChair,
                    killSwitch: vin.killSwitch,
                    weightClass: vin.weightClass,
                    displayVinId: vin.displayVinId,
                  }));
              } else {
                // For non-WTA, keep existing structure
                return [vin];
              }
            })
            .flat();

          return {
            ...material,
            vins: transformedVins || [],
          };
        });

        setMaterialList((prev) => ({ ...prev, materials: materialsWithVins }));

        let workTicketListData = materialsWithVins?.map((material) => {
          return {
            id: material.id || "",
            MMID: material.materialId,
            itemDescription: material.materialName,
            type: material.processingCode,
            displayType: getFullName(TYPE_DROPDOWN, material.processingCode),
            contractItem: material.contractName,
            quantity: material.totalQty,
            MmidPgiDate: material.materialId + " - " + props?.data?.pgiDate,
            esns: material.esn,
            trackingNumbers: material.trackingNumbers,
            trackingUrls: material.trackingUrls,
            deliveryBlock: material.deliveryBlock,
            carriers: material.carriers,
            pgiDate: material.pgiDate,
            pgiQty: material.pgiQty,
            salesOrder: material.salesOrder,
            x_purchaseOrder: material.x_purchaseOrder,
            deliveryDocNumber: material.deliveryDocNumber,
            wtMaterialId: material.mid,
            contractId: material.cid,
            sapId: material.sapId,
            techRefId: material.techRefId,
            bundleId: material.bundleId,
            defaultReturnType: material.defaultReturnType,
            customerMaterialCharge: material.customerMaterialCharge,
            materialChargeCurrency: material.materialChargeCurrency,
            totalQty: material.totalQty,
            orderType: material.orderType,
            contractOverride: material.contractOverride,
            esnstobeRemoved: material.esnstobeRemoved,
            vins: material.vins || [],
          };
        });
        setWorkTicketData(workTicketListData);
      }

      let vins =
        response?.length > 0
          ? response?.filter((item) => item.vin || (item.year && item.make && item.model)).map((item, index) => ({ ...item, index: index + 1 }))
          : [];
      setWorkTicketVehicles(vins);
      setLoader(false);
    } else {
      setMaterialList((prev) => ({ ...prev, vins: [] }));
      notify("Unable to fetch VIN list due to an unexpected error", "error");
      setLoader(false);
    }
  };

  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} />);
  };

  return (
    <>
      <Loader active={isLoading} fullscreen />
      {commonModalStatus && (
        <WTCommonModal
          commonModalStatus={commonModalStatus}
          setCommonModalStatus={setCommonModalStatus}
          ticketDetails={props.data}
          notify={notify}
          title={title}
          subTitle={subTitle}
          actionItem={actionItem}
          modal={modal}
          handleShipmentDamagedModal={handleShipmentDamagedModal}
          handleLostShipmentModal={handleLostShipmentModal}
          handleCancelShipment={handleCancelShipment}
          getWorkTicketList={() => getWorkTicketMateriallist(true)}
        />
      )}
      {splitByMaterialModal && (
        <Modal
          role="dialog"
          ariaLabel="Split by Material"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif", paddingLeft: "0.7rem" }}>
                <Title size="medium">Split by Material</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setSplitByMaterialModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody>
            <p style={{ fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif" }}>
              Splitting by material is against standard business practices and should only happen in rare cases with manager approval. Please only
              move forward if you gained approval from a deployment leader.
            </p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <div>
              <input
                id="split-by-ack-checkbox"
                checked={splitByAckSelected}
                aria-checked={splitByAckSelected}
                type="checkbox"
                name="default"
                style={{ width: "20px", height: "20px" }}
                onChange={() => {
                  setSplitByAckSelected(!splitByAckSelected);
                }}
              />
              <label
                htmlFor="split-by-ack-checkbox"
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  top: "-4px",
                  position: "relative",
                  display: "inline-block",
                  paddingLeft: "6px",
                  fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif",
                }}
              >
                Acknowledgement
              </label>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  paddingLeft: "25px",
                  color: "black",
                  fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                  marginTop: "4px",
                }}
              >
                By moving forward with splitting, you are acknowledging that this is approved by leadership.
              </div>
            </div>
          </ModalBody>
          <ModalFooter css={{ justifyContent: "end !important" }}>
            <FlexRow justifyContent="flex-end" width="100%">
              <CustomSLButton
                aria-label="Cancel"
                role="button"
                css={{ padding: "0 10px 0 10px" }}
                secondary
                onClick={() => {
                  setSplitByMaterialModal(false);
                  setSplitByAckSelected(false);
                  setSelectedAction("");
                }}
              >
                Cancel
              </CustomSLButton>
              <CustomSLButton
                aria-label="Split By Material"
                disabled={!splitByAckSelected}
                role="button"
                primary
                onClick={() => {
                  setSplitByMaterialModal(false);
                  setSplitByAckSelected(false);
                  showSplitByMaterialView(props.data);
                  setSelectedAction("");
                }}
              >
                Split By Material
              </CustomSLButton>
            </FlexRow>
          </ModalFooter>
        </Modal>
      )}
      <Header>
        <FlexRow onClick={(event) => event.preventDefault()}>
          {props?.data?.ticketId} {isWTA && ` - ${props?.data?.workticketType}`}
          {isWTA && props?.data?.workticketType === "Outbound" && (
            <div style={{ marginLeft: "auto", display: "flex", gap: "10px", alignItems: "center" }}>
              <CustomDropdown
                value={selectedAction}
                onChange={(e) => setSelectedAction(e.target.value)}
                disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
              >
                <option value="" disabled>
                  Select Action
                </option>
                {getActionOptions().map((option) => (
                  <option value={option.value} key={option.value}>
                    {option.label}
                  </option>
                ))}
              </CustomDropdown>
              <Button
                size="small"
                secondary
                aria-label="Refresh"
                role="button"
                aria-disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                onClick={() => {
                  getWorkTicketMateriallist(true);
                }}
              >
                Refresh
              </Button>
              <Button
                size="small"
                primary
                aria-label="Save"
                role="button"
                disabled={!selectedAction || limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                onClick={handleActionChange}
              >
                Save
              </Button>
            </div>
          )}
          {(!isWTA || props?.data?.workticketType !== "Outbound") && (
            <Button
              size="small"
              secondary
              aria-label="Refresh"
              role="button"
              aria-disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
              disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
              css={{ marginLeft: "20px", marginTop: "5px" }}
              onClick={() => {
                getWorkTicketMateriallist(true);
              }}
            >
              Refresh
            </Button>
          )}
        </FlexRow>
      </Header>

      {notification}
      <AccordionWrapper>
        <Accordion activeIndex={0} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          <AccordionTab header="Items">
            <GridComponentWrapper>
              <GridComponent
                isExportEnabled={false}
                noDataMessage="No data available to display"
                rows={workTicketData}
                hideGlobalFilter={true}
                columns={isWTA ? WORK_TICKET_AUTOMATION_VIEW_ITEM_TABLE_COL : WORK_VIEW_ITEM_TABLE_COL}
                paginator={false}
                whiteSpace="normal"
                rowExpansionTemplate={rowExpansionTemplate}
              />
            </GridComponentWrapper>
          </AccordionTab>
        </Accordion>
      </AccordionWrapper>
      {/* {!isSourceCSP.isSourceCSP && ( VZC42148-1817
        <AccordionWrapper>
          <Accordion role="region" activeIndex={0} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
            <AccordionTab aria-label="Order Tracking" header="Order Tracking">
              <OrderTrackingInfoTable data={orderTrackingData} />
            </AccordionTab>
          </Accordion>
        </AccordionWrapper>
      )} */}
      <AccordionWrapper>
        <Accordion role="region" activeIndex={5} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          <AccordionTab aria-label="Vehicles" header="Vehicles">
            <div tabIndex={0} aria-label="vehicle list table">
              {isWTA ? (
                <VehiclesDisplayTable data={workTicketVehicles} />
              ) : (
                <GridComponent
                  isExportEnabled={false}
                  noDataMessage="No data available to display"
                  rows={workTicketVehicles}
                  hideGlobalFilter={true}
                  columns={WORK_VIEW_VEHICLE_TABLE_COL}
                  paginator={false}
                />
              )}
            </div>
          </AccordionTab>
        </Accordion>
      </AccordionWrapper>
      <WorkViewItemTable data={materialList} AccountID={props?.AccountID} ID={props?.ID} userId={props?.userId} setNotification={setNotification} />
    </>
  );
}

export const DetailedWorkTicketViewMetadata = {
  name: "Detailed Work Ticket View",
  id: "Detailed_Work_Ticket_View",
  component: lazy(() => import("./DetailedWorkTicketView")),
  route: "/detailed_work_ticket_view",
};
